import AbcIcon from '@mui/icons-material/Abc';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import EuroIcon from '@mui/icons-material/Euro';
import HexagonOutlinedIcon from '@mui/icons-material/HexagonOutlined';
import ListIcon from '@mui/icons-material/List';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import NumbersIcon from '@mui/icons-material/Numbers';
import PercentIcon from '@mui/icons-material/Percent';
import TableChartIcon from '@mui/icons-material/TableChart';
import { SxProps, Tooltip } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

const TYPE_CONFIG: Record<DataTypesT, React.ElementType> = {
    date: CalendarTodayIcon,
    datetime: AccessTimeIcon,
    year: CalendarMonthIcon,
    time: AccessTimeIcon,
    integer: NumbersIcon,
    float: NumbersIcon,
    fraction: PercentIcon,
    money: EuroIcon,
    category: ListIcon,
    enum: ListIcon,
    text: AbcIcon,
    coordinates: LocationOnIcon,
    polygon: HexagonOutlinedIcon,
    tree: AccountTreeIcon,
    table: TableChartIcon,
};

type Props = {
    type: DataTypesT;
    sx?: SxProps;
    color?: 'default' | 'inherit' | 'primary' | 'secondary';
};

const DataTypeIcon = ({ type, sx = {}, color = 'default' }: Props) => {
    const { t } = useTranslation();
    const IconComponent = TYPE_CONFIG[type];
    return (
        <Tooltip title={t(`dataCatalog.${type}`)} placement="top">
            <IconComponent
                color={color}
                sx={{
                    fontSize: '1rem',
                    flexShrink: 0,
                    ...sx,
                }}
            />
        </Tooltip>
    );
};

export default DataTypeIcon;
